<mat-form-field class="example-full-width emerald-dropdown" appearance="outline">
  <mat-label>{{ label }} <span *ngIf="required" class="required">*</span></mat-label>
  <mat-select
    [(ngModel)]="_value"
    [compareWith]="compareWith"
    [multiple]="multiSelect"
    [disabled]="disabled"
    (selectionChange)="onDataChange($event.value)">
    <mat-option *ngFor="let option of options" [value]="option[valueKey]">
      <mat-icon *ngIf="iconKey && option[iconKey]" class="option-icon">{{ option[iconKey] }}</mat-icon>
      {{ option[displayKey] }}
    </mat-option>
  </mat-select>
</mat-form-field>
